import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useContext,
} from "react";

import clsx from "clsx";

import PerfectScrollbar from "react-perfect-scrollbar";
import axios from "axios";
import {
  Hidden,
  Drawer,
  Paper,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";

import { connect } from "react-redux";
import UserContext from "contexts/userContext";
import { useHistory } from "react-router-dom";
import SidebarHeader from "layout-components/SidebarHeader";
import SidebarUserbox from "layout-components/SidebarUserbox";
import SidebarMenu from "layout-components/SidebarMenu";
import SidebarFooter from "layout-components/SidebarFooter";
import { useIdleTimer } from "react-idle-timer";
import navItems from "./navItems";
import { getPerms2 } from "./menuPerms";
import {
  fetcher,
  add,
  del,
  blank,
  closeSnack,
  notify,
} from "utils/MyFunctions";
import feedbackContext from "contexts/feedbackContext";
import httpService from "utils/HttpService";
import { AuthContext } from "utils/AuthContext";

import {
  setSidebarToggleMobile,
  setSidebarHover,
  setSidebarToggle,
  setSidebarFooter,
  setSidebarUserbox,
} from "reducers/ThemeOptions";

const timeout = 10_000;
const promptBeforeIdle = 4_000;

const Sidebar = (props) => {
  const {
    setSidebarToggleMobile,
    sidebarToggleMobile,
    sidebarFixed,

    sidebarHover,
    setSidebarHover,
    sidebarToggle,
    sidebarUserbox,
    sidebarShadow,
    sidebarFooter,
  } = props;
  const { feedback, setFeedback, enqueueSnackbar, closeSnackbar } = useContext(
    feedbackContext
  );
  const toggleHoverOn = () => setSidebarHover(true);
  const toggleHoverOff = () => setSidebarHover(false);

  const closeDrawer = () => setSidebarToggleMobile(!sidebarToggleMobile);
  const { isAuthenticated, login, logout } = useContext(AuthContext);
  /**
   * Session expiration timer
   */

  const [open, setOpen] = useState(false);
  const { role, setRole, locale } = useContext(UserContext);
  const SECURITY_API_URL =
    // "http://127.0.0.1:8300/api/";
    process.env.REACT_APP_SECURITY_API_URL;
  const [isIdle, setIsIdle] = useState(false);
  const [remainingTime, setRemainingTime] = useState(30); // 20 seconds countdown
  const history = useHistory();
  const idleTimerRef = useRef(null);
  const countdownIntervalRef = useRef(null);
  const MONOLITH_API_URL = process.env.REACT_APP_MONOLITH_API_URL;

  useEffect(() => {
    console.log("sidebar initiated, role : ", role, " locale : ", locale);
    // navItems.map((list) => {
    //   console.log("list : ", list);
    //   console.log("list locale key : ", list["label_" + locale]);
    // });
  }, []);

  useEffect(() => {
    if (role.user && role.user.company) {
      console.log("CHECKING BLOCKAGE...");
      let config = {
        method: "POST",
        maxBodyLength: Infinity,
        url: MONOLITH_API_URL + "/bescs/can-create",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
        },
        data: {
          company_uuid:
            role && role.user && role.user.company["unique_identification"],
        },
      };
      axios
        .request(config)
        .then((response) => {
          console.log("resp : ", response.data);
          console.log("SETTING ROLE ADDING BLOCKAGE, current role : ", role);
          if (response.data.decision) {
            setRole((role) => ({ ...role, ["blocked"]: false }));
          } else {
            setRole((role) => ({ ...role, ["blocked"]: true }));
          }
        })
        .catch((error) => {
          console.log("error!! error below :");
          console.log(error);
          return error;
        });
    }
  }, [role.user]);

  const handleSignOut = () => {
    setFeedback({ ...feedback, ["bdOpen"]: true });
    let sb = notify(
      "Traitement en cours...",
      "info",
      "center",
      "bottom",
      false,
      enqueueSnackbar
    );
    httpService
      .postWithHeader(SECURITY_API_URL + "logout/user", {})
      .then((response) => {
        if (response.data.success) {
          localStorage.clear();
          logout();
          history.push("/");
        }
        setFeedback({ ...feedback, ["bdOpen"]: false });
        closeSnack(sb, closeSnackbar);
        notify(
          response.data.ResponseText,
          response.data.success ? "success" : "error",
          "center",
          "top",
          true,
          enqueueSnackbar
        );
      })
      .catch((error) => {
        console.log("leo----------------error");
        console.log(error);
        setFeedback({ ...feedback, ["bdOpen"]: false });
        closeSnack(sb, closeSnackbar);
        console.log(error);

        if (error?.response && error.response.status === 401) {
          notify(
            "Votre session a expiré. Veuillez vous reconnecter",
            "error",
            "center",
            "top",
            true,
            enqueueSnackbar
          );
          localStorage.clear();
          logout();
          history.push("/");
        }else{
          localStorage.clear();
          logout();
          history.push("/")
        }
      });
  };

  const onIdle = () => {
    console.log("onIdle");
    setOpen(true);
    setIsIdle(true);
    setRemainingTime(30); // Reset countdown
    countdownIntervalRef.current = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(countdownIntervalRef.current);
          handleSignOut();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  };

  const handleContinueSession = () => {
    setIsIdle(false);
    setOpen(false);
    clearInterval(countdownIntervalRef.current);
    if (idleTimerRef.current) {
      idleTimerRef.current.reset();
    }
  };

  useIdleTimer({
    ref: idleTimerRef,
    timeout: 1000 * 60 * 15, // 30 minute(s)
    onIdle: onIdle,
    debounce: 500,
  });
  /**
   * Session expiration timer
   */

  const sidebarMenuContent = (
    <div
      className={clsx({
        "app-sidebar-nav-close": sidebarToggle && !sidebarHover,
      })}
    >
      {navItems.map(
        (list) =>
          true &&
          getPerms2(list, list.label, role) && (
            <SidebarMenu
              component="div"
              key={list.label}
              pages={list.content}
              title={list["label_" + locale]}
            />
          )
      )}
    </div>
  );

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          open={sidebarToggleMobile}
          onClose={closeDrawer}
          variant="temporary"
          elevation={4}
          className="app-sidebar-wrapper-lg"
        >
          <SidebarHeader />
          <PerfectScrollbar>
            {sidebarUserbox && <SidebarUserbox />}
            {sidebarMenuContent}
            {sidebarFooter && <SidebarFooter />}
          </PerfectScrollbar>
        </Drawer>
      </Hidden>

      <Hidden mdDown>
        <Paper
          onMouseEnter={toggleHoverOn}
          onMouseLeave={toggleHoverOff}
          className={clsx("app-sidebar-wrapper", {
            "app-sidebar-wrapper-close": sidebarToggle,
            "app-sidebar-wrapper-open": sidebarHover,
            "app-sidebar-wrapper-fixed": sidebarFixed,
          })}
          square
          open={sidebarToggle}
          elevation={sidebarShadow ? 11 : 3}
        >
          <SidebarHeader />
          <div
            className={clsx({
              "app-sidebar-menu": sidebarFixed,
              "app-sidebar-collapsed": sidebarToggle && !sidebarHover,
            })}
          >
            <PerfectScrollbar options={{ wheelPropagation: false }}>
              {/* {sidebarUserbox && <SidebarUserbox />} */}
              {sidebarMenuContent}
              {sidebarFooter && <SidebarFooter />}
            </PerfectScrollbar>
          </div>
        </Paper>
      </Hidden>

      <Dialog
        open={open}
        onClose={handleContinueSession}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Session inactive</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Votre session est inactive et vous serez déconnecté dans{" "}
            {remainingTime} s...
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            type="button"
            color="secondary"
            onClick={handleContinueSession}
            variant="contained"
          >
            Restez actif!
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  sidebarFixed: state.ThemeOptions.sidebarFixed,
  headerFixed: state.ThemeOptions.headerFixed,
  sidebarToggle: state.ThemeOptions.sidebarToggle,
  sidebarHover: state.ThemeOptions.sidebarHover,
  sidebarShadow: state.ThemeOptions.sidebarShadow,
  sidebarFooter: state.ThemeOptions.sidebarFooter,
  sidebarUserbox: state.ThemeOptions.sidebarUserbox,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile,
});

const mapDispatchToProps = (dispatch) => ({
  setSidebarToggleMobile: (enable) => dispatch(setSidebarToggleMobile(enable)),
  setSidebarToggle: (enable) => dispatch(setSidebarToggle(enable)),
  setSidebarHover: (enable) => dispatch(setSidebarHover(enable)),
  setSidebarFooter: (enable) => dispatch(setSidebarFooter(enable)),
  setSidebarUserbox: (enable) => dispatch(setSidebarUserbox(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
